import { render, staticRenderFns } from "./purchaseReturnTemplate.vue?vue&type=template&id=ec2e577a&scoped=true"
import script from "./purchaseReturnTemplate.vue?vue&type=script&lang=js"
export * from "./purchaseReturnTemplate.vue?vue&type=script&lang=js"
import style0 from "./purchaseReturnTemplate.vue?vue&type=style&index=0&id=ec2e577a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2e577a",
  null
  
)

export default component.exports